import React, { useCallback, useEffect, useState } from "react";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import GameHeader from "common/components/GameHeader/GameHeader";
import EducationSidebar from "features/educationVideo/components/EducationSidebar";
import Video from "features/educationVideo/components/Video/Video";
import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";

import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import "./styles.scss";

import VideoImg from "assets/images/video-img.png";
import VideoPosterImg from "assets/images/videoPoster.png";
import { useTypedDispatch } from "store";
import { getAllVideos, getVideosForCustomer } from "store/users/thunkActions";
import debounce from "lodash.debounce";
import { showMobile } from "helpers/adaptation";
import EducationalVideoMobile from "./EducationalVideoMobile";
import { ICommonResponse, ICourse, IVideo } from "types/common";
import ModalExpiredGame from "../../features/game/components/ModalExpiredGame/ModalExpiredGame";

function EducationalVideo() {
  const dispatch = useTypedDispatch();
  const [allVideos, setAllVideos] = useState<IVideo[]>([]);
  const [allCourses, setAllCourses] = useState<ICourse[]>([]);
  const [currentVideo, setCurrentVideo] = useState<IVideo["Data"] | null>(null);
  const [play, setPlay] = useState(false);
  const [isSubscriptionModalVisible, setIsSubscriptionModalVisible] = useState(false);

  const getData = useCallback(
    debounce(async (CourseId: number) => {
      try {
        const res = (await dispatch(getVideosForCustomer(CourseId))) as unknown as ICommonResponse<
          IVideo[]
        >;
        setAllVideos(res?.Results);
      } catch (err) {
        console.error("Failed to fetch videos:", err);
      }
    }, 200),
    [dispatch]
  );

  const handleVideoSelect = (videoData: IVideo["Data"]) => {
    if (videoData.Url) {
      setIsSubscriptionModalVisible(false);
      setCurrentVideo(null);
      setTimeout(() => {
        setCurrentVideo(videoData);
        setPlay(true);
      }, 200);
    } else {
      // 👇 Використовується новий сеттер стану
      setIsSubscriptionModalVisible(true);
    }
  };

  const getAllVideoCourses = async () => {
    const res = (await dispatch(getAllVideos())) as unknown as ICommonResponse<ICourse[]>;
    setAllCourses(res?.Results);
  };

  useEffect(() => {
    getAllVideoCourses();
  }, []);

  useEffect(() => {
    if (allCourses[0]?.Data?.Id_Course) {
      getData(allCourses[0].Data.Id_Course);
    }
  }, [allCourses, getData]);

  return (
    <>
      {showMobile && <EducationalVideoMobile />}
      {!showMobile && (
        <div className="EducationalVideo-screen-wrapper">
          {!showMobile && <GameHeader />}
          {showMobile && <MainPageHeaderMobile />}
          <div className="EducationalVideo-wrapper-otr">
            <div className="EducarionalSidebar-main">
              <h2 className="heading" style={{ fontWeight: 900 }}>
                וידאו והדרכות
              </h2>
              <div className="Educarional-sidebar">
                <h3 className="heading-sidebar">
                  <span>בחר נושא:</span>
                </h3>
                <EducationSidebar
                  courses={allCourses}
                  videos={allVideos}
                  onClickCourse={(val: number) => {
                    setPlay(false);
                    setCurrentVideo(null);
                    setTimeout(() => {
                      getData(val);
                    }, 500);
                  }}
                  onClickVideo={handleVideoSelect}
                  onCloseVideo={() => {
                    setCurrentVideo(null);
                    setPlay(false);
                  }}
                  play={play}
                  setPlay={setPlay}
                />
              </div>
            </div>
            <div className="EducationalVideo-wrapper-inr">
              <h2 className="heading">{currentVideo?.Title}</h2>
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <div className="video-videoSidebar">
                  <ModalExpiredGame
                    visible={isSubscriptionModalVisible}
                    onClose={() => setIsSubscriptionModalVisible(false)}
                  />
                  <div className="video-heading-otr">
                    <div className="video-otr">
                      {currentVideo?.Url ? (
                        <Video
                          key={currentVideo.Url}
                          type={currentVideo.VideoType}
                          source={currentVideo.Url}
                          play={play}
                        />
                      ) : (
                        <img
                          style={{
                            width: "100%",
                            borderRadius: 20,
                            backgroundColor: "#000"
                          }}
                          src={VideoPosterImg}
                          alt="Video poster"
                        />
                      )}
                    </div>
                    <p className="video-desc">{currentVideo?.Description || ""}</p>
                  </div>
                  <div className="videoSidebar">
                    <div className="videoSidebar-inr">
                      <Nav variant="pills" className="video-ul">
                        {allVideos?.length > 0 &&
                          allVideos.map((val: IVideo) => {
                            return (
                              <Nav.Item
                                className="video-li"
                                key={val.Data.Id}
                                onClick={() => handleVideoSelect(val.Data)}>
                                <Nav.Link eventKey={val.Data.Id.toString()}>
                                  <div className="video-otr">
                                    <img className="video-img" src={VideoImg} alt="img" />
                                  </div>
                                  <p className="video-text">{val?.Data?.Title}</p>
                                </Nav.Link>
                              </Nav.Item>
                            );
                          })}
                      </Nav>
                    </div>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
          <MainFooterComponent />
        </div>
      )}
    </>
  );
}

export default EducationalVideo;
